import { useIsAuthenticated } from "@/hooks/useIsAuthenticated.ts";
import { Outlet, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useStore } from "@/stores/useStore.ts";

export const AppLayoutPage = () => {
  useIsAuthenticated();
  const [isLoading, setIsLoading] = useState(true);
  const { tenantId } = useParams();
  const allowedTenants = useStore((s) => s.allowedTenants);
  const store = useStore();

  useEffect(() => {
    if (!allowedTenants || allowedTenants.length === 0) return;
    setIsLoading(true);
    if (tenantId && allowedTenants.map((t) => t.id).includes(tenantId)) {
      store.subscribeTenant(tenantId).then(() => setIsLoading(false));
    }
  }, [allowedTenants]);

  return (
    <Outlet
      context={{
        isLoading: isLoading,
      }}
    />
  );
};
